export default "__VITE_ASSET__8ae45e5c__"